import { ChildModel, ModelBase } from 'store/model-base';
import { StatementCredit } from './credit';
import { SsmStatementLineItem } from './line/ssm-item';
import { ChargeType, PaymentState, SERVICE_PROMO_ACCOUNT } from 'my-account/constants';
import { StatementDataDetails } from './data/detail';
import { LineItemCharge } from './line/charge';
import { StatementPlanChange } from './plan-change';
import { StatementOnetimeCharges } from './onetime-charges';
import { OrderTaxFee } from 'store/order/models';
import { SsmServicePromotions } from './ssm-service-promotions';
import { Util } from 'services/util';
import { PaymentInfo } from 'store/credit-card/models';

export class SsmEstimatedMessage extends ModelBase {
    public static storeName: string = 'ssmEstimatedMessage';
    public cycleStartDate: string;
    public cycleEndDate: string;
    public autoPayDate: string;
    public paymentInfo: PaymentInfo;
    public cycleTotal: number;
    public planChanges: StatementPlanChange[];
    public credits: StatementCredit[];
    public creditReversals: StatementCredit[];
    public servicePromotions: SsmServicePromotions[];
    public statementLineItems: SsmStatementLineItem[];
    public byTheGigDataCost: number;
    public paymentState: PaymentState;
    public state: PaymentState;
    public hasSharedData: boolean;
    public data: StatementDataDetails;
    public accountLevelFees: LineItemCharge[];
    public serviceCredits: StatementCredit[];
    public serviceCreditTotal: number;
    public reverseCreditTotal: number;
    public promoCredits: StatementCredit[];
    public promoCharges: LineItemCharge[];
    public hasCredits: boolean;
    public oneTimeCharges: StatementOnetimeCharges;
    public oneTimeTotal: number;
    public oneTimeChargesList: OneTimeCharge[];
    public taxAndFees: OrderTaxFee[];
    public taxTotal: number;
    public isLegacy: boolean;
    public promoCreditsAndDiscounts: StatementCredit[];

    public static create<T extends ModelBase>(response: ApiResponse): T {

        response.serviceCredits = response.credits?.filter((data: StatementCredit) => data.creditType !== SERVICE_PROMO_ACCOUNT);
        response.serviceCreditTotal = response.serviceCredits && response.serviceCredits.reduce((total: number, credit: StatementCredit) => total + credit.creditAmount, 0);
        response.reverseCreditTotal = response.creditReversals && response.creditReversals.reduce((total: number, credit: StatementCredit) => total + credit.creditAmount, 0);

        response.hasCredits = response.serviceCredits && response.serviceCredits.length > 0;
        response.promoCredits = response.credits?.filter((data: StatementCredit) => data.creditType === SERVICE_PROMO_ACCOUNT);
        response.lineItemcharges = response.statementLineItems.map((lineItem: SsmStatementLineItem) => lineItem.charges);
        response.promoCharges = response.lineItemcharges.flat().filter((charge: LineItemCharge) => charge.chargeCategory?.toUpperCase() === ChargeType.SERVICE_PROMO_LINE);
        response.promoCreditsAndDiscounts = Array.isArray(response.credits) ? response.credits : [];

        
        response.oneTimeChargesList = response?.oneTimeCharges?.charges;
        response.oneTimeTotal = response?.oneTimeCharges?.oneTimeTotal;

        if (response.isPaid) {
            response.createdDate = response.paymentInfo && Util.dateFormat(response.paymentInfo.createdDate, 'MMM dd yyyy');
        }

        return super.create<T>(response);
    }

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'paymentInfo',
            model: PaymentInfo
        },
        {
            attrName: 'data',
            model: StatementDataDetails
        }];
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'planChanges',
            model: StatementPlanChange
        }, {
            attrName: 'credits',
            model: StatementCredit
        }, {
            attrName: 'creditReversals',
            model: StatementCredit
        }, {
            attrName: 'statementLineItems',
            model: SsmStatementLineItem
        }, {
            attrName: 'accountLevelFees',
            model: LineItemCharge
        }, {
            attrName: 'promoCredits',
            model: StatementCredit
        }, {
            attrName: 'promoCharges',
            model: LineItemCharge
        }, {
            attrName: 'servicePromotions',
            model: LineItemCharge
        }, {
            attrName: 'lineItemcharges',
            model: LineItemCharge
        }, {
            attrName: 'taxAndFees',
            model: OrderTaxFee
        }];
    }

}
